import classNames from 'classnames';
import { MaterialIcon } from '../MaterialIcon';
import { tagColor } from '../Tag';
import { CcBadge } from './types';
import { CC_CARD_TEXT } from './utils';

/**
 * The full-width band above the card image: one signal (FR-1.2). The icon and the label are always
 * black, so they read on every colour.
 */
export const CcProductCardBadge: React.FC<CcBadge> = ({
  label,
  color,
  icon,
}) => (
  <div
    data-component="cc-product-card-badge"
    className={classNames(
      CC_CARD_TEXT.badge,
      'flex items-center gap-spacing/gap/soft-6px px-spacing/padding/x-sm py-spacing/padding/soft-8px',
      tagColor(color),
    )}
  >
    <MaterialIcon icon={icon} px={14} className="shrink-0 text-text/primary" />
    <span className="line-clamp-1 text-text/primary">{label}</span>
  </div>
);
